import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie'
import router from './router/index'
import './assets/css/base.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Toast } from 'vant'

Vue.use(Vant);


Vue.config.productionTip = false


Vue.use(VueAxios,axios)
Vue.use(VueCookie);

Vue.use(ElementUI);


axios.interceptors.request.use(function(request){
  //loading、请求地址替换、修改
  return request;
});
// { code:0,data:'',message:'' }
axios.interceptors.response.use(function(response){
  let res = response.data;
  if(res.code != 0){
    Toast(res.message);
  }
  return response;
},function(error){
  return Promise.reject(error);
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
